/*
 * Returns a parsed Date from an ISO string
 * @param {String} the date string
 * @return {Date} the date object
 */
var parseIOSLocal = function parseIOSLocal(str) {
  var b = str.split(/\D/);
  return new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5]);
};

export default parseIOSLocal;